// ManageSettings.jsx
import React, { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { toast } from "react-toastify";

export default function ManageSettings() {
  const [loading, setLoading] = useState(true);

  // Settings state
  const [settings, setSettings] = useState({
    siteName: "Generic Ideas",
    supportEmail: "support@genericideas.com",
    phoneNumber: "+1 234 567 890",
  });

  const docRef = doc(db, "settings", "general");

  useEffect(() => {
    async function fetchSettings() {
      try {
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          setSettings((prev) => ({ ...prev, ...snap.data() }));
        }
      } catch (err) {
        console.error("Error fetching settings:", err);
        toast.error("Failed to load settings.");
      } finally {
        setLoading(false);
      }
    }
    fetchSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <div className="p-8 text-center text-gray-500 animate-pulse">Loading settings...</div>;
  }

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold text-gray-900">Site Settings</h1>
          <p className="text-sm text-gray-500">Manage site-wide content and offers.</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm overflow-hidden p-6 text-center text-gray-500">
        <p>No additional settings at this time. Promotional Banner settings have been moved under Offers & Coupons.</p>
      </div>
    </div>
  );
}
